import PaymentItem from 'routes/LeadList/components/PaymentItem/PaymentItem';

export default PaymentItem;
